import PhotoSwipeLightbox from "//www.skinnymixes.com/cdn/shop/t/221/assets/a-photoswipe-lightbox.js?v=13651888854280649141783519615"

const l_pdpLightBox = new PhotoSwipeLightbox({
  gallery: "#LMainProductMedia",
  children: "[data-pswp-link]",
  pswpModule: () => import("//www.skinnymixes.com/cdn/shop/t/221/assets/a-photoswipe.js?v=63091533421035891871783519616"),
  bgOpacity: 1,
  close: false,
  zoom: false,
  arrowNext: false,
  arrowPrev: false,
  counter: false,
  preloader: false,
  wheelToZoom: true,
})

const uiElements = [
  {
    name: "l-close",
    order: 11,
    isButton: true,
    html: `<svg
      class="l-pswp__button-close"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>`,
    onClick: (event, el, pswp) => pswp.close(),
  },
  {
    name: "l-arrowNext",
    order: 12,
    isButton: true,
    html: `<svg
        aria-hidden="true"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" />
      </svg>`,
    onClick: (event, el, pswp) => pswp.next(),
  },
  {
    name: "l-arrowPrev",
    order: 10,
    isButton: true,
    html: `<svg
        aria-hidden="true"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6" />
      </svg>`,
    onClick: (event, el, pswp) => pswp.prev(),
  },
]

l_pdpLightBox.on("uiRegister", () => {
  l_pdpLightBox.pswp.ui.registerElement(uiElements[0])
  uiElements.slice(1).forEach((element) => l_pdpLightBox.pswp.ui.registerElement(element))
})

l_pdpLightBox.init()
